import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function EctdPublishingSoftware() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'IT Solutions for Pharma', 'eCTD Publishing Software']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          IT Solutions for Pharma
        </h2>

        {/* Section Title */}
        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            eCTD Publishing Software
          </h3>
        </div>

        {/* Intro */}
        <h4 className="text-md font-bold text-[#05326D] mb-4 pl-3">
          Streamlined Global Dossier Management for Regulatory Submissions
        </h4>

        <p className="mb-4 text-[#05326D]">
          Our eCTD Publishing Software is a powerful, web-based solution designed to simplify and accelerate regulatory submissions across global markets. Built for pharmaceutical, biotech, and life sciences organizations, this intuitive, ready-to-use platform enables seamless dossier publishing, lifecycle management, and multi-user collaboration—all without the need for complex IT infrastructure.
        </p>
        <p className="mb-8 text-[#05326D]">
          Whether you’re submitting to the US FDA, EMA, GCC, AU-TGA, Health Canada, Swissmedic, MCC-ZA, Thai-FDA, or JFDA, our software ensures full compliance with regional specifications and supports a wide range of submission types.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        {/* Pre-Configured Templates */}

        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Pre-Configured Templates for Global Authorities
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">US FDA (v2.01 & v2.3)</p>
        <p className="ml-2 mt-2 text-[#05326D]">EMA (EU v3.0.3)</p>
        <p className="ml-2 mt-2 text-[#05326D]">GCC (v1.2 & v1.5)</p>
        <p className="ml-2 mt-2 text-[#05326D]">AU-TGA (v3.1)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Health Canada (v2.2)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Swissmedic (CH v1.4)</p>
        <p className="ml-2 mt-2 text-[#05326D]">South Africa MCC-ZA (v2.1)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Thailand Thai-FDA (v1.0)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Jordan JFDA (v1.0.2)</p>
        <p className="ml-2 mt-2 text-[#05326D]">NeeS Specifications (EU v4.0, GCC v1.2 & v1.5, AU v2.0)</p>


        {/* Supported Submission Types */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Supported Submission Types
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">IND, NDA, ANDA, BLA</p>
        <p className="ml-2 mt-2 text-[#05326D]">DMF (Type I–IV)</p>
        <p className="ml-2 mt-2 text-[#05326D]">ASMF, CEP</p>
        <p className="ml-2 mt-2 text-[#05326D]">DCP, MRP, National & Centralized Procedures</p>


        {/* Key Features & Benefits */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Key Features & Benefits
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Web-Based Platform: No heavy infrastructure required</p>
        <p className="ml-2 mt-2 text-[#05326D]">Multi-User Collaboration: Parallel access in a user-friendly environment</p>
        <p className="ml-2 mt-2 text-[#05326D]">Smart Replication: Reuse submissions across regions to reduce repetitive work</p>
        <p className="ml-2 mt-2 text-[#05326D]">Project-Level Dashboards: Real-time status tracking by user and dossier</p>
        <p className="ml-2 mt-2 text-[#05326D]">Document Reusability: Share common files across multiple submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Auto PDF Optimization: Corrects properties and ensures compliance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Built-In Technical Validator: Ensures eCTD structure and format accuracy</p>
        <p className="ml-2 mt-2 text-[#05326D]">Automated File Naming: Converts filenames to meet regulatory standards</p>
        <p className="ml-2 mt-2 text-[#05326D]">Event Reminders: Stay ahead of regulatory timelines</p>
        <p className="ml-2 mt-2 text-[#05326D]">Reduced Preparation Time: Accelerates submission readiness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Minimized User Dependency: Simplifies workflow for all team members</p>


        {/* Proven Performance */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Proven Performance
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Over 1,000 eCTD dossiers successfully published</p>
        <p className="ml-2 mt-2 text-[#05326D]">Trusted by clients in 20+ countries</p>
        <p className="ml-2 mt-2 text-[#05326D]">35+ installations across global organizations</p>
        <p className="ml-2 mt-2 text-[#05326D]">More than 2,000 SPLs published</p>


        <p className="text-sm text-[#05326D] mt-4">
          Our eCTD software is designed to empower regulatory teams with speed, accuracy, and flexibility—making global submissions easier than ever.
        </p>
      </div>
    </div>
  );
}

export default EctdPublishingSoftware;
